"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("core-js/modules/es6.regexp.to-string");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _moment = _interopRequireDefault(require("moment"));

var _helper = require("@/mixins/helper/helper");

var _loading = require("@/mixins/loading/loading");

var _milkRunV = require("@/mixins/milk-run-v2/milk-run-v2");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MilkRunLogsComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(MilkRunLogsComponent, _Mixins);

  var _super = _createSuper(MilkRunLogsComponent);

  function MilkRunLogsComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, MilkRunLogsComponent);
    _this = _super.apply(this, arguments);
    _this.maxDays = 30;
    _this.dateRange = [(0, _moment.default)(new Date()).subtract(1, 'days').format('YYYY-MM-DD'), (0, _moment.default)(new Date()).add(1, 'days').format('YYYY-MM-DD')];
    _this.pagination = {
      currentPage: 1,
      pageSize: 50,
      totalData: 0
    };
    _this.data = [];
    _this.alertType = [];
    _this.showAll = false;
    return _this;
  }

  (0, _createClass2.default)(MilkRunLogsComponent, [{
    key: "$timezone",
    get: function get() {
      return this.helper.get(this.$userData, 'timezone', 8);
    }
  }, {
    key: "created",
    value: function () {
      var _created = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function created() {
        return _created.apply(this, arguments);
      }

      return created;
    }()
  }, {
    key: "isValidDateRange",
    value: function isValidDateRange(dateRange) {
      var startDate = (0, _moment.default)(dateRange[0]);
      var endDate = (0, _moment.default)(dateRange[1]);

      var duration = _moment.default.duration(endDate.diff(startDate)).asDays();

      if (duration > this.maxDays) {
        var message = {
          title: this.$i18n.t('general.queryExceed1Month'),
          duration: 5000
        };

        _elementUi.Notification.error(message);

        return false;
      }

      return true;
    }
  }, {
    key: "getData",
    value: function () {
      var _getData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var payload, res, pagination;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.isValidDateRange(this.dateRange)) {
                  _context2.next = 13;
                  break;
                }

                this.loading = true;
                payload = {
                  startDate: this.dateRange[0],
                  endDate: this.dateRange[1],
                  page: this.pagination['currentPage'],
                  limit: this.pagination['pageSize'],
                  query: !this.showAll ? 'message:updatestatus.order' : ''
                };

                if (this.alertType.length > 0) {
                  payload['query'] = payload['query'] + "|logType:".concat(this.alertType.toString());
                }

                _context2.next = 6;
                return this.milkRunV2API.getAllLogs(payload);

              case 6:
                res = _context2.sent;

                if (res && !res.failed && !this.helper.isUndefined(res.data)) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", null);

              case 9:
                pagination = this.helper.get(res, 'pagination', {
                  currentPage: 1,
                  pageSize: 50,
                  totalData: 0
                });
                this.pagination = _objectSpread(_objectSpread({}, this.pagination), {}, {
                  currentPage: pagination['currentPage'],
                  totalData: pagination['totalData']
                });
                this.data = this.helper.get(res, 'data', []);
                this.loading = false;

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }()
  }, {
    key: "handlePagination",
    value: function () {
      var _handlePagination = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(val, type) {
        var p;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                p = _objectSpread({}, this.pagination);

                if (type === 'sizeChange') {
                  p.currentPage = 1;
                  p.pageSize = val;
                }

                if (type === 'currentChange') {
                  p.currentPage = val;
                }

                this.pagination = _objectSpread({}, p);
                _context3.next = 6;
                return this.getData();

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handlePagination(_x, _x2) {
        return _handlePagination.apply(this, arguments);
      }

      return handlePagination;
    }()
  }, {
    key: "tableClassName",
    value: function tableClassName(_ref) {
      var row = _ref.row,
          columnIndex = _ref.columnIndex;

      if (columnIndex === 1) {
        return (row.logType || '').toLowerCase();
      } else {
        return '';
      }
    }
  }, {
    key: "getStatusLogs",
    value: function getStatusLogs(data) {
      var lStatus = data.data && data.data.status ? data.data.status.toLowerCase() : 'active';
      var lLogType = data.logType ? data.logType.toLowerCase() : 'normal';

      if (data.userEmail === 'cron@logflows') {
        return this.$i18n.t("logs.".concat(data.message.toLowerCase(), "logs").concat(lStatus));
      }

      return this.$i18n.t("logs.".concat(data.message.toLowerCase()).concat(lLogType).concat(lStatus));
    }
  }]);
  return MilkRunLogsComponent;
}((0, _vuePropertyDecorator.Mixins)(_helper.HelperMixin, _loading.LoadingMixin, _milkRunV.MilkRunV2Mixin));

MilkRunLogsComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LogsComponent',
  components: {
    'el-table': _elementUi.Table,
    'el-table-column': _elementUi.TableColumn,
    'el-date-picker': _elementUi.DatePicker,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-button': _elementUi.Button,
    'el-pagination': _elementUi.Pagination,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-checkbox': _elementUi.Checkbox
  }
})], MilkRunLogsComponent);
var _default = MilkRunLogsComponent;
exports.default = _default;